module.exports = __webpack_public_path__ + "static/media/loading.05adbd75.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.gif
// module id = 466
// module chunks = 0